<div mat-dialog-title class="ds">
  <span id="dialogTitle">{{appStrings.accounts_search}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
@if (loading) {
  <div class="loading" [ngClass]="{'mobile': isMobile}">
    <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
@if (!loading) {
  <div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
    <div class="projects-search-container">
      <form [formGroup]="projectsSearchForm" (keyup.enter)="btnCallback(1)">
        <ds-autocomplete id="projectOwner" [isDisabled]="isAccountManager" class="fill-width" [options]="accountManagers"
          [label]="appStrings.followUp_projects_projectOwner" [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"
          [control]="projectsSearchForm.controls.projectOwnerId"
        ></ds-autocomplete>
        <ds-textfield id="companyName" class="fill-width" [label]="appStrings.followUp_projects_companyName"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="projectsSearchForm.controls.companyName"
        ></ds-textfield>
        <ds-textfield id="projectName" class="fill-width" [label]="appStrings.followUp_projects_projectName"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'" [control]="projectsSearchForm.controls.projectName"
        ></ds-textfield>
        <ds-textfield id="contactName" class="fill-width" [label]="appStrings.followUp_projects_contactName"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"  [control]="projectsSearchForm.controls.contactName"
        ></ds-textfield>
        <ds-select id="projectStatus" class="fill-width" [label]="appStrings.label_status" [dropOptions]="statuses"
          [label_orientation]="isMobile ? 'horizontal-label' : 'vertical-label'"  [control]="projectsSearchForm.controls.statusId"
        ></ds-select>
      </form>
    </div>
  </div>
}
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
        [type]="button.type" (onClick)="btnCallback(i)" [label]="button.label" [isDisabled]="button.disableEmpty && disableButtons">
      </ds-button>
    }
  </div>
</div>
